import React from 'react';
import { useMenu } from 'hooks';
import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import { Image } from 'components';

const EditorialItem = ({
	editorial,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(editorial, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(editorial, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(editorial.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(editorial)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(editorial)}
						name="editorial"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={editorial.image_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{editorial.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{editorial.featured ? 'Yes' : '-'}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{editorial.published ? 'Yes' : '-'}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">
					{editorial.premium ? 'Yes' : '-'}
				</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default EditorialItem;
